import React, { useState, useMemo, useRef } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import ContentBlock from 'components/ContentBlock'
import { Form, Text, Select } from 'components/forms'
import { useQuery, useMutation } from 'components/graphql'
import { UploaderComponent, StyledContainerNoDimensions } from 'components/Image'
import getCCRoute from '../gql/getCCRoute'
import updateCCRoute from '../gql/updateCCRoute'
import { listCashRegisters } from 'gql/query'
import getQueryName from 'helpers/getNameOfGqlQuery'
import { notEmpty } from 'helpers/validators'

const ClickAndCollect = () => {
	const initRoute = useRef()
	const queryName = useMemo(() => getQueryName(getCCRoute), [])
	const { data } = useQuery(getCCRoute, {
		onCompleted: res => {
			const fetchedRoute = res?.cashAssist?.[queryName]?.id
			initRoute.current = fetchedRoute
			if(fetchedRoute !== route) {
				setRoute(fetchedRoute)
			}
		}
	})
	const [route, setRoute] = useState(data?.[queryName]?.id || '')
	const [isUploading, setIsUploading] = useState()

	const [updateCC] = useMutation(updateCCRoute, {
		onCompleted: () => {
			if(isUploading) {
				setIsUploading(false)
			}
		}
	})
	const [t] = useTranslation()

	const handleSubmit = ({ id, ...vals }) => {
		const mutationVals = { id: initRoute.current, fields: vals }
		if(id !== initRoute.current) {
			mutationVals.fields.route = id
		}
		updateCC({
			variables: mutationVals
		})
	}

	const handleLogoUpload = file => {
		setIsUploading(true)
		const reader = new FileReader()

		reader.readAsDataURL(file)
		reader.onload = () => {
			updateCC({
				variables: {
					id: data?.[queryName]?.id,
					fields: { logo: reader.result }
				}
			})
		}
	}
	const handleDelLogo = () => {
		setIsUploading(true)
		updateCC({
			variables: {
				id: data?.[queryName]?.id,
				fields: { logo: null }
			}
		})
	}

	return (
		<ContentBlock>
			<Form initialValues={data?.[queryName]} onSubmit={handleSubmit} smartSubmit>
				<Row>
					<Col xs>
						<Text
							field='id'
							label={t('options_section.fields.site_url')}
							{...notEmpty()}
							validateOnChange
						/>
						<Select
							field='cashRegisterId'
							label={t('common.fields.cash_register')}
							remoteOptions={{
								query: listCashRegisters
							}}
							valueField='id'
							labelField='name'
						/>
					</Col>
					<Col xs>
						<StyledContainerNoDimensions hasImg={!!data?.[queryName]?.logoUrl}>
							<UploaderComponent
								src={data?.[queryName]?.logoUrl}
								imgKey={data?.[queryName]?.logoUrl}
								label={t('options_section.fields.logo')}
								handleDelete={handleDelLogo}
								handleUpload={handleLogoUpload}
								isUploading={isUploading}
							/>
						</StyledContainerNoDimensions>
					</Col>
				</Row>
			</Form>
		</ContentBlock>
	)
}

export default ClickAndCollect
